import { Pagination } from '@material-ui/lab';

const CustomPagination = ({ total, current, onPageChange }) => {
  const handleChange = (e, page) => (page === 1 ? onPageChange(0) : onPageChange(page - 1));

  return (
    <div className="flex justify-end mt-16">
      <Pagination
        variant="outlined"
        size="medium"
        shape="rounded"
        color="primary"
        showFirstButton
        showLastButton
        page={current + 1}
        count={total}
        onChange={handleChange}
      />
    </div>
  );
};

export default CustomPagination;
